import SetCurrentComponent from "@/core/services/SetCurrentComponent";
const reserva_de_vagas_nao_confirmadas = {
  path: "/reserva-de-vagas-nao-confirmadas",
  redirect: "/reserva-de-vagas-nao-confirmadas",
  meta: {
    breadCrumb: "Atendimento ao Aluno - Reserva de Vagas não Confirmadas",
  },
  children: [
    {
      path: "/reserva-de-vagas-nao-confirmadas",
      name: "/reserva_de_vagas_nao_confirmadas",
      component: SetCurrentComponent(
        "ReservaDeVagasNaoConfirmadas",
        "ReservaDeVagasNaoConfirmadas"
      ),
    },
    {
      path: "/reserva-de-vagas-nao-confirmadas/cancelar/:id",
      name: "reserva_de_vagas_nao_confirmadas_cancelar",
      component: SetCurrentComponent(
        "ReservaDeVagasNaoConfirmadas/pages/vaga",
        "CancelarReservaNaoConfirmada"
      ),
    },
    {
      path: "/reserva-de-vagas-nao-confirmadas/confirma-matricula/:id",
      name: "reserva_de_vagas_nao_confirmadas_confirma_matricula",
      component: SetCurrentComponent(
        "ReservaDeVagasNaoConfirmadas/pages/vaga",
        "ConfirmaMatricula"
      ),
    },
    {
      path: "/reserva-de-vagas-nao-confirmadas/reemissao-da-carta/:id",
      name: "reserva_de_vagas_nao_confirmadas_reemissao_da_carta",
      component: SetCurrentComponent(
        "ReservaDeVagasNaoConfirmadas/pages/vaga",
        "ReemissaoDaCarta"
      ),
    },
  ],
};

export { reserva_de_vagas_nao_confirmadas };
